import { Injectable } from "@angular/core";
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { empty } from 'rxjs';
import { switchMap } from "rxjs/operators";


@Injectable()
export class Globals {
  
  // apiUrl: string = 'http://localhost:3000/server/api';
  apiUrl: string = 'http://www.romaef.com:3000/server/api';
  sound: string = 'equalizer';
  
  // another var 
  routesObject: any;
  url: any;
  router: any;
  private sub: any;

  constructor(location: Location, router: Router,private route: ActivatedRoute){
    this.url = location.path();
    this.router = router;
  }

  // methods
  menuLoadder(){
    setTimeout(function(){
        document.getElementById('loading').classList.add("hideLoad");
        document.getElementById('loadingAnimation').classList.add("rotateOut");
        // setTimeout(function()
        //     document.getElementById('animation').classList.add("hide");
        // },1500)
        setTimeout(function(){
          document.getElementById('loading').classList.add("hide");
          document.getElementById('loading').classList.remove("hideLoad");
          document.getElementById('loadingAnimation').classList.remove("rotateOut");
  
        },2000)
    },2000);
  }

  toggleSound(){
    // console.log('no lo creo')
    let name: string;
      if(this.sound == 'equalizer'){
        name = 'volume_off';
      }
      if(this.sound == 'volume_off'){
        name = 'equalizer';
      }

      let audioSection:any = document.getElementById("audioSection");
      if(name == 'volume_off'){
        audioSection.pause();
      }
      if(name == 'equalizer'){
        audioSection.play();
      }
      // document.getElementById("audioSection").volume = 0.1; 
      // console.log('llego? > '+name);
      this.sound = name;
      return name;
  }

  switchSound(){
    let audioSection:any = document.getElementById("audioSection");
    if(this.sound == 'volume_off'){
      audioSection.pause();
    }
    if(this.sound == 'equalizer'){
      audioSection.play();
    }
  }

  disableScrolling(){
    var x=window.scrollX;
    var y=window.scrollY;
    window.onscroll=function(){window.scrollTo(x, y);};
  }

  enableScrolling(){
      window.onscroll=function(){};
  }

  goToContact(){
    console.log('this.url > ',this.router.url);
    if(this.router.url == '/' || this.router.url == '/home' || this.router.url == '/home/1'){
      // this.enableScrolling();
      $('html, body').animate({
          scrollTop: $(document).height()
      }, 1200);
    }else{
        // this.enableScrolling();
        this.router.navigate(['/home/1']);
    }
  }

  checkIfIsInTheHome(contact){
    if((this.router.url == '/home/1' && contact == "1") || this.router.url == '/home/1'){
      // this.enableScrolling();
      setTimeout(()=>{
        // console.log('scroll automático');
        $('html, body').animate({
            scrollTop: $(document).height()
        }, 1200);
      }, 3000);
    }
  }


}